// frontend/src/components/wizard/StepReview/ScheduleSettings.jsx
import React, { useState, useEffect } from 'react';
import { Power, Calendar, Globe, Clock, X } from 'lucide-react';
import { useWizardStore } from '../../../store/useWizardStore';
import { useLanguageStore } from '../../../store/useLanguageStore'; // 🟢 1. Importar el Store de Idiomas

const TIMEZONES = [
  {
    group: "🌎 South America", options: [
      { v: "America/Lima", l: "Lima, Bogotá, Quito (UTC-5)" },
      { v: "America/Santiago", l: "Santiago (UTC-4)" },
      { v: "America/Argentina/Buenos_Aires", l: "Buenos Aires (UTC-3)" },
      { v: "America/Sao_Paulo", l: "São Paulo (UTC-3)" },
      { v: "America/La_Paz", l: "La Paz (UTC-4)" },
      { v: "America/Caracas", l: "Caracas (UTC-4)" },
      { v: "America/Asuncion", l: "Asunción (UTC-4)" },
      { v: "America/Montevideo", l: "Montevideo (UTC-3)" }
    ]
  },
  {
    group: "🌎 North America", options: [
      { v: "America/Mexico_City", l: "Ciudad de México (UTC-6)" },
      { v: "America/New_York", l: "Nueva York, Miami (UTC-5)" },
      { v: "America/Chicago", l: "Chicago (UTC-6)" },
      { v: "America/Denver", l: "Denver (UTC-7)" },
      { v: "America/Los_Angeles", l: "Los Ángeles (UTC-8)" },
      { v: "America/Toronto", l: "Toronto (UTC-5)" },
      { v: "America/Vancouver", l: "Vancouver (UTC-8)" },
      { v: "America/Anchorage", l: "Anchorage (UTC-9)" },
      { v: "America/Halifax", l: "Halifax (UTC-4)" },
    ]
  },
  {
    group: "🌎 Central America and the Caribbean", options: [
      { v: "America/Panama", l: "Panamá (UTC-5)" },
      { v: "America/Guatemala", l: "Guatemala (UTC-6)" },
      { v: "America/Santo_Domingo", l: "Santo Domingo (UTC-4)" },
      { v: "America/Havana", l: "La Habana (UTC-5)" },
      { v: "America/Puerto_Rico", l: "San Juan (UTC-4)" }
    ]
  },
  {
    group: "🌍 Western Europe", options: [
      { v: "Europe/London", l: "Londres (UTC+0)" },
      { v: "Europe/Lisbon", l: "Lisboa (UTC+0)" },
      { v: "Europe/Dublin", l: "Dublín (UTC+0)" },
      { v: "Atlantic/Reykjavik", l: "Reikiavik (UTC+0)" }
    ]
  },
  {
    group: "🌍 Central Europe", options: [
      { v: "Europe/Madrid", l: "Madrid, París, Roma (UTC+1)" },
      { v: "Europe/Berlin", l: "Berlín (UTC+1)" },
      { v: "Europe/Amsterdam", l: "Ámsterdam (UTC+1)" },
      { v: "Europe/Brussels", l: "Bruselas (UTC+1)" },
      { v: "Europe/Vienna", l: "Viena (UTC+1)" },
      { v: "Europe/Stockholm", l: "Estocolmo (UTC+1)" },
      { v: "Europe/Oslo", l: "Oslo (UTC+1)" },
      { v: "Europe/Copenhagen", l: "Copenhague (UTC+1)" },
      { v: "Europe/Warsaw", l: "Varsovia (UTC+1)" },
      { v: "Europe/Prague", l: "Praga (UTC+1)" },
      { v: "Europe/Budapest", l: "Budapest (UTC+1)" }
    ]
  },
  {
    group: "🌍 Eastern Europe", options: [
      { v: "Europe/Athens", l: "Atenas (UTC+2)" },
      { v: "Europe/Istanbul", l: "Estambul (UTC+3)" },
      { v: "Europe/Moscow", l: "Moscú (UTC+3)" },
      { v: "Europe/Helsinki", l: "Helsinki (UTC+2)" },
      { v: "Europe/Bucharest", l: "Bucarest (UTC+2)" },
      { v: "Europe/Sofia", l: "Sofía (UTC+2)" },
      { v: "Europe/Kyiv", l: "Kiev (UTC+2)" },
    ]
  },
  {
    group: "🌍 Africa", options: [
      { v: "Africa/Cairo", l: "El Cairo (UTC+2)" },
      { v: "Africa/Johannesburg", l: "Johannesburgo (UTC+2)" },
      { v: "Africa/Lagos", l: "Lagos (UTC+1)" },
      { v: "Africa/Nairobi", l: "Nairobi (UTC+3)" },
      { v: "Africa/Casablanca", l: "Casablanca (UTC+0)" },
      { v: "Africa/Algiers", l: "Argel (UTC+1)" },
      { v: "Africa/Tunis", l: "Túnez (UTC+1)" },
      { v: "Africa/Accra", l: "Acra (UTC+0)" },
      { v: "Africa/Addis_Ababa", l: "Addis_Ababa (UTC+3)" }
    ]
  },
  {
    group: "🌍 Middle East", options: [
      { v: "Asia/Dubai", l: "Dubái (UTC+4)" },
      { v: "Asia/Riyadh", l: "Riad (UTC+3)" },
      { v: "Asia/Tehran", l: "Teherán (UTC+3:30)" },
      { v: "Asia/Jerusalem", l: "Jerusalén (UTC+2)" },
      { v: "Asia/Baghdad", l: "Bagdad (UTC+3)" },
      { v: "Asia/Amman", l: "Amán (UTC+2)" },
      { v: "Asia/Beirut", l: "Beirut (UTC+2)" },
      { v: "Asia/Damascus", l: "Damasco (UTC+2)" },
      { v: "Asia/Kuwait", l: "Kuwait (UTC+3)" },
      { v: "Asia/Qatar", l: "Doha (UTC+3)" }
    ]
  },
  {
    group: "🌍 Central and South Asia", options: [
      { v: "Asia/Kolkata", l: "Nueva Delhi, Mumbai (UTC+5:30)" },
      { v: "Asia/Karachi", l: "Karachi (UTC+5)" },
      { v: "Asia/Dhaka", l: "Daca (UTC+6)" },
      { v: "Asia/Colombo", l: "Colombo (UTC+5:30)" },
      { v: "Asia/Kathmandu", l: "Katmandú (UTC+5:45)" },
      { v: "Asia/Tashkent", l: "Taskent (UTC+5)" },
      { v: "Asia/Almaty", l: "Almatý (UTC+6)" }
    ]
  },
  {
    group: "🌍 East and Southeast Asia", options: [
      { v: "Asia/Tokyo", l: "Tokio (UTC+9)" },
      { v: "Asia/Shanghai", l: "Shanghái, Pekín (UTC+8)" },
      { v: "Asia/Seoul", l: "Seúl (UTC+9)" },
      { v: "Asia/Bangkok", l: "Bangkok (UTC+8)" },
      { v: "Asia/Singapore", l: "Singapur (UTC+8)" },
      { v: "Asia/Jakarta", l: "Yakarta (UTC+7)" },
      { v: "Asia/Ho_Chi_Minh", l: "Ho Chi Minh (UTC+7)" },
      { v: "Asia/Manila", l: "Manila (UTC+8)" },
      { v: "Asia/Kuala_Lumpur", l: "Kuala Lumpur (UTC+8)" },
      { v: "Asia/Taipei", l: "Taipéi (UTC+8)" },
      { v: "Asia/Hong_Kong", l: "Hong Kong (UTC+8)" }
    ]
  },
  {
    group: "🌍 Oceania", options: [
      { v: "Australia/Sydney", l: "Sídney, Melbourne (UTC+11)" },
      { v: "Australia/Perth", l: "Perth (UTC+8)" },
      { v: "Australia/Adelaide", l: "Adelaida (UTC+10:30)" },
      { v: "Australia/Brisbane", l: "Brisbane (UTC+10)" },
      { v: "Australia/Darwin", l: "Darwin (UTC+9:30)" },
      { v: "Pacific/Auckland", l: "Auckland (UTC+13)" },
      { v: "Pacific/Fiji", l: "Fiyi (UTC+12)" },
      { v: "Pacific/Port_Moresby", l: "Puerto Moresby (UTC+10)" },
      { v: "Pacific/Honolulu", l: "Hawái (UTC-10)" },
      { v: "Pacific/Guam", l: "Guam (UTC+10)" },
      { v: "Pacific/Tahiti", l: "Tahití (UTC-10)" }
    ]
  },
  {
    group: "🌐 Universal Time", options: [
      { v: "UTC", l: "UTC (Universal Time Coordinated)" }
    ]
  }
];

const getLocalToday = () => {
  const d = new Date();
  const pad = (n) => n.toString().padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const ScheduleSettings = ({ onScheduleChange }) => {
  const { t, language } = useLanguageStore(); // 🟢 Obtenemos el idioma actual (es, en, pt). Instanciamos i18n

  // 🟢 CREAMOS LOS DÍAS DINÁMICAMENTE SEGÚN EL IDIOMA
  const getDaysOfWeek = () => {
    if (language === 'en') {
      return [
        { id: 1, label: 'M', name: 'Monday' }, { id: 2, label: 'T', name: 'Tuesday' },
        { id: 3, label: 'W', name: 'Wednesday' }, { id: 4, label: 'T', name: 'Thursday' },
        { id: 5, label: 'F', name: 'Friday' }, { id: 6, label: 'S', name: 'Saturday' },
        { id: 0, label: 'S', name: 'Sunday' }
      ];
    }
    if (language === 'pt') {
      return [
        { id: 1, label: 'S', name: 'Segunda-feira' }, { id: 2, label: 'T', name: 'Terça-feira' },
        { id: 3, label: 'Q', name: 'Quarta-feira' }, { id: 4, label: 'Q', name: 'Quinta-feira' },
        { id: 5, label: 'S', name: 'Sexta-feira' }, { id: 6, label: 'S', name: 'Sábado' },
        { id: 0, label: 'D', name: 'Domingo' }
      ];
    }
    // Por defecto (Español)
    return [
      { id: 1, label: 'L', name: 'Lunes' }, { id: 2, label: 'M', name: 'Martes' },
      { id: 3, label: 'X', name: 'Miércoles' }, { id: 4, label: 'J', name: 'Jueves' },
      { id: 5, label: 'V', name: 'Viernes' }, { id: 6, label: 'S', name: 'Sábado' },
      { id: 0, label: 'D', name: 'Domingo' }
    ];
  };

  const DAYS_OF_WEEK = getDaysOfWeek(); // 🟢 Lo instanciamos

  const {
    isActive, setIsActive, runMode, setRunMode, startDate, setStartDate,
    hasEndDate, setHasEndDate, endDate, setEndDate,
    cronExpression, setCronExpression, timezone, setTimezone,
    pipelineStatus, setPipelineStatus, scheduleUI, setScheduleUI
  } = useWizardStore();

  const [schedType, setSchedType] = useState(scheduleUI?.schedType || 'daily');
  const [time, setTime] = useState(scheduleUI?.time || '09:00');
  const [timeEnd, setTimeEnd] = useState(scheduleUI?.timeEnd || '22:00');
  const [interval, setIntervalVal] = useState(scheduleUI?.interval || '2');
  const [intervalUnit, setIntervalUnit] = useState(scheduleUI?.intervalUnit || 'hours');
  const [selectedDays, setSelectedDays] = useState(scheduleUI?.selectedDays || [1, 2, 3, 4, 5]);
  const [monthDays, setMonthDays] = useState(scheduleUI?.monthDays || ['1', '15']);

  useEffect(() => {
    let cleanUI = { schedType };
    if (schedType === 'hourly') {
      cleanUI = { ...cleanUI, time, timeEnd, interval, intervalUnit, selectedDays };
    } else if (schedType === 'daily') {
      cleanUI = { ...cleanUI, time, selectedDays };
    } else if (schedType === 'biweekly') {
      cleanUI = { ...cleanUI, time, monthDays: [monthDays[0], monthDays[1]] };
    } else if (schedType === 'monthly') {
      cleanUI = { ...cleanUI, time, monthDays: [monthDays[0]] };
    }
    setScheduleUI(cleanUI);
  }, [schedType, time, timeEnd, interval, intervalUnit, selectedDays, monthDays, setScheduleUI]);

  const handleTimeChange = (newTime) => {
    setTime(newTime);
    if (timeEnd <= newTime) {
      const h = parseInt(newTime.split(':')[0], 10);
      setTimeEnd(`${Math.min(23, h + 1).toString().padStart(2, '0')}:00`);
    }
  };

  const handleTimeEndChange = (newEnd) => {
    if (newEnd <= time) {
      const h = parseInt(time.split(':')[0], 10);
      setTimeEnd(`${Math.min(23, h + 1).toString().padStart(2, '0')}:00`);
    } else setTimeEnd(newEnd);
  };

  const handleIntervalChange = (val) => {
    let numStr = val.replace(/[^0-9]/g, '');
    if (numStr === '') { setIntervalVal(''); return; }
    let num = parseInt(numStr, 10);
    if (intervalUnit === 'minutes') { if (num > 59) num = 59; }
    else { if (num > 23) num = 23; }
    setIntervalVal(num.toString());
  };

  const handleIntervalBlur = () => {
    let num = parseInt(interval, 10) || 0;
    if (intervalUnit === 'minutes' && num < 10) setIntervalVal('10');
    if (intervalUnit === 'hours' && num < 1) setIntervalVal('1');
  };

  const toggleDay = (dayId) => setSelectedDays(prev => prev.includes(dayId) ? prev.filter(d => d !== dayId) : [...prev, dayId]);

  useEffect(() => {
    if (schedType === 'custom') return;
    let expr = '';
    const [h, m] = time.split(':');
    const [hEnd] = timeEnd.split(':');
    const daysStr = selectedDays.length > 0 ? selectedDays.sort().join(',') : '*';
    const safeInterval = parseInt(interval, 10) || 1;

    if (schedType === 'hourly') {
      const hoursRange = `${parseInt(h, 10)}-${parseInt(hEnd, 10)}`;
      expr = intervalUnit === 'hours'
        ? `${parseInt(m, 10)} ${hoursRange}/${safeInterval} * * ${daysStr}`
        : `${parseInt(m, 10)}/${safeInterval} ${hoursRange} * * ${daysStr}`;
    }
    else if (schedType === 'daily') expr = `${parseInt(m, 10)} ${parseInt(h, 10)} * * ${daysStr}`;
    else if (schedType === 'biweekly') expr = `${parseInt(m, 10)} ${parseInt(h, 10)} ${monthDays.join(',')} * *`;
    else if (schedType === 'monthly') expr = `${parseInt(m, 10)} ${parseInt(h, 10)} ${monthDays[0]} * *`;

    setCronExpression(expr);
  }, [schedType, time, timeEnd, interval, intervalUnit, selectedDays, monthDays, setCronExpression]);

  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
      <div className={`p-6 border-b flex items-center justify-between transition-colors ${isActive ? 'bg-indigo-600 border-indigo-700' : 'bg-slate-100 border-slate-200'}`}>
        <div>
          <h3 className={`font-bold text-lg flex items-center ${isActive ? 'text-white' : 'text-slate-500'}`}>
            <Power className="w-5 h-5 mr-2" /> {isActive ? (t('wizard.review.schedule.active_cfg') || 'Configuración Activa') : (t('wizard.review.schedule.inactive_cfg') || 'Configuración Inactiva')}
          </h3>
          <p className={`text-xs mt-1 ${isActive ? 'text-indigo-200' : 'text-slate-400'}`}>
            {t('wizard.review.schedule.draft_warn') || 'Si apagas esto, solo se guardará como borrador.'}
          </p>
        </div>
        <button
          onClick={() => { setIsActive(!isActive); setPipelineStatus(!isActive ? 1 : 2); }}
          disabled={pipelineStatus === 0}
          className={`w-14 h-8 flex items-center rounded-full p-1 transition-colors duration-300 ${isActive ? 'bg-white' : 'bg-slate-300'} ${pipelineStatus === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <div className={`bg-indigo-600 w-6 h-6 rounded-full shadow-md transform transition-transform duration-300 ${isActive ? 'translate-x-6' : 'translate-x-0 bg-white'}`}></div>
        </button>
      </div>

      <div className="p-6 space-y-5">
        <div className={`transition-all duration-300 ${pipelineStatus === 0 ? 'opacity-50 pointer-events-none select-none grayscale-[50%]' : ''}`}>
          <div>
            <label className="text-xs font-bold text-slate-500 uppercase mb-1.5 block">
              {t('wizard.review.schedule.freq') || 'Frecuencia de Ejecución'}
            </label>
            <div className="flex bg-slate-100 rounded-xl p-1">
              <button onClick={() => setRunMode('once')} className={`flex-1 py-2 text-sm font-bold rounded-lg transition-all ${runMode === 'once' ? 'bg-white text-indigo-700 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}>
                {t('wizard.review.schedule.once') || 'Solo Una Vez'}
              </button>
              <button onClick={() => setRunMode('scheduled')} className={`flex-1 py-2 text-sm font-bold rounded-lg transition-all ${runMode === 'scheduled' ? 'bg-white text-indigo-700 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}>
                {t('wizard.review.schedule.scheduled') || 'Programado (Auto)'}
              </button>
            </div>
          </div>

          {runMode === 'scheduled' && (
            <div className="space-y-5 border-t border-slate-100 pt-5 animate-in slide-in-from-top-2">

              {/* FECHAS */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-xs font-bold text-slate-500 uppercase mb-1.5 flex items-center">
                    <Calendar className="w-3.5 h-3.5 mr-1" /> {t('wizard.review.schedule.start') || 'Inicio'}
                  </label>
                  <input
                    type="date"
                    value={startDate}
                    min={getLocalToday()}
                    onChange={(e) => setStartDate(e.target.value)}
                    onBlur={(e) => {
                      const today = getLocalToday();
                      let val = e.target.value;
                      if (!val || val < today) val = today;
                      setStartDate(val);
                      if (hasEndDate && endDate < val) setEndDate(val);
                    }}
                    className="w-full text-sm border-slate-200 rounded-xl p-2 focus:ring-indigo-500 bg-slate-50"
                  />
                </div>

                <div>
                  <div className="flex items-center mb-1.5 space-x-2">
                    <input type="checkbox" id="chkEnd" checked={hasEndDate} onChange={(e) => {
                      setHasEndDate(e.target.checked);
                      if (e.target.checked) {
                        const [y, m, d] = startDate.split('-');
                        const start = new Date(y, m - 1, d);
                        start.setDate(start.getDate() + 1);
                        const pad = (n) => n.toString().padStart(2, '0');
                        setEndDate(`${start.getFullYear()}-${pad(start.getMonth() + 1)}-${pad(start.getDate())}`);
                      } else {
                        setEndDate('');
                      }
                    }} className="w-4 h-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" />
                    <label htmlFor="chkEnd" className="text-xs font-bold text-slate-500 uppercase cursor-pointer flex items-center">
                      <Calendar className="w-3.5 h-3.5 mr-1" /> {t('wizard.review.schedule.end') || 'Fin'}
                    </label>
                  </div>
                  {hasEndDate ? (
                    <input
                      type="date"
                      value={endDate}
                      min={startDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      onBlur={(e) => {
                        let val = e.target.value;
                        if (!val || val < startDate) val = startDate;
                        setEndDate(val);
                      }}
                      className="w-full text-sm border-slate-200 rounded-xl p-2 focus:ring-indigo-500 bg-white border-indigo-200"
                    />
                  ) : (
                    <div className="w-full text-xs p-2 text-slate-400 bg-slate-50 rounded-xl border border-dashed border-slate-200 text-center py-2.5">
                      {t('wizard.review.schedule.no_limit') || 'Sin límite'}
                    </div>
                  )}
                </div>
              </div>

              {/* TIPO DE PERIODICIDAD */}
              <div>
                <label className="text-xs font-bold text-slate-500 uppercase mb-1.5 block">
                  {t('wizard.review.schedule.periodicity') || 'Periodicidad'}
                </label>
                <select value={schedType} onChange={(e) => {
                  setSchedType(e.target.value);
                  if (e.target.value === 'hourly') setIntervalUnit('hours');
                }} className="w-full text-sm border-slate-200 rounded-xl p-2 focus:ring-indigo-500 bg-slate-50">
                  <option value="hourly">{t('wizard.review.schedule.hourly') || 'Horaria'}</option>
                  <option value="daily">{t('wizard.review.schedule.daily') || 'Diaria / Semanal'}</option>
                  <option value="biweekly">{t('wizard.review.schedule.biweekly') || 'Quincenal'}</option>
                  <option value="monthly">{t('wizard.review.schedule.monthly') || 'Mensual'}</option>
                  <option value="custom">{t('wizard.review.schedule.custom') || 'Personalizado (CRON)'}</option>
                </select>
              </div>

              {/* BLOQUE HOURLY */}
              {schedType === 'hourly' && (
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-100 space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-xs font-bold text-slate-500">{t('wizard.review.schedule.from_hour') || 'Desde (Hora)'}</label>
                      <input type="time" value={time} onChange={e => handleTimeChange(e.target.value)} className="w-full mt-1 p-2 rounded-lg border-slate-200 text-sm" />
                    </div>
                    <div>
                      <label className="text-xs font-bold text-slate-500">{t('wizard.review.schedule.to_hour') || 'Hasta (Hora)'}</label>
                      <input type="time" value={timeEnd} onChange={e => handleTimeEndChange(e.target.value)} className="w-full mt-1 p-2 rounded-lg border-slate-200 text-sm" />
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-bold text-slate-500">{t('wizard.review.schedule.every') || 'Cada:'}</span>
                    <input type="text" value={interval} onChange={e => handleIntervalChange(e.target.value)} onBlur={handleIntervalBlur} className="w-16 p-2 rounded-lg border-slate-200 text-sm text-center" />
                    <select value={intervalUnit} onChange={e => {
                      setIntervalUnit(e.target.value);
                      if (e.target.value === 'minutes') setIntervalVal('10'); else setIntervalVal('2');
                    }} className="p-2 rounded-lg border-slate-200 text-sm outline-none">
                      <option value="hours">{t('wizard.review.schedule.hours_max') || 'Horas (Máx 23)'}</option>
                      <option value="minutes">{t('wizard.review.schedule.mins_max') || 'Minutos (Máx 59)'}</option>
                    </select>
                  </div>
                  <div>
                    <label className="text-xs font-bold text-slate-500 block mb-1">
                      {t('wizard.review.schedule.days_of_week') || 'Días de la semana'}
                    </label>
                    <div className="flex space-x-1.5 mt-2">
                      {DAYS_OF_WEEK.map(d => (
                        <button key={d.id} type="button" title={d.name} onClick={() => toggleDay(d.id)} className={`w-8 h-8 rounded-full text-xs font-bold transition-all ${selectedDays.includes(d.id) ? 'bg-indigo-600 text-white shadow-md' : 'bg-slate-200 text-slate-500 hover:bg-slate-300'}`}>
                          {d.label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* BLOQUE DAILY */}
              {schedType === 'daily' && (
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-100 space-y-4">
                  <div>
                    <label className="text-xs font-bold text-slate-500">{t('wizard.review.schedule.time') || 'Hora de ejecución'}</label>
                    <input type="time" value={time} onChange={e => setTime(e.target.value)} className="w-full mt-1 p-2 rounded-lg border-slate-200 text-sm" />
                  </div>
                  <div>
                    <label className="text-xs font-bold text-slate-500 block mb-1">
                      {t('wizard.review.schedule.days_of_week') || 'Días de la semana'}
                    </label>
                    <div className="flex space-x-1.5 mt-2">
                      {DAYS_OF_WEEK.map(d => (
                        <button key={d.id} type="button" title={d.name} onClick={() => toggleDay(d.id)} className={`w-8 h-8 rounded-full text-xs font-bold transition-all ${selectedDays.includes(d.id) ? 'bg-indigo-600 text-white shadow-md' : 'bg-slate-200 text-slate-500 hover:bg-slate-300'}`}>
                          {d.label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* BLOQUE BIWEEKLY */}
              {schedType === 'biweekly' && (
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-100 space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-xs font-bold text-slate-500 block mb-1">{t('wizard.review.schedule.day_1') || 'Día 1'}</label>
                      <select value={monthDays[0]} onChange={e => setMonthDays([e.target.value, monthDays[1]])} className="w-full p-2 rounded-lg border-slate-200 text-sm">
                        {[...Array(31)].map((_, i) => <option key={i + 1} value={i + 1}>{i + 1}</option>)} <option value="L">{t('wizard.review.schedule.last_of_month') || 'Último del mes (L)'}</option>
                      </select>
                    </div>
                    <div>
                      <label className="text-xs font-bold text-slate-500 block mb-1">{t('wizard.review.schedule.day_2') || 'Día 2'}</label>
                      <select value={monthDays[1]} onChange={e => setMonthDays([monthDays[0], e.target.value])} className="w-full p-2 rounded-lg border-slate-200 text-sm">
                        {[...Array(31)].map((_, i) => <option key={i + 1} value={i + 1}>{i + 1}</option>)} <option value="L">{t('wizard.review.schedule.last_of_month') || 'Último del mes (L)'}</option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <label className="text-xs font-bold text-slate-500">{t('wizard.review.schedule.time') || 'Hora'}</label>
                    <input type="time" value={time} onChange={e => setTime(e.target.value)} className="w-full mt-1 p-2 rounded-lg border-slate-200 text-sm" />
                  </div>
                </div>
              )}

              {/* BLOQUE MONTHLY */}
              {schedType === 'monthly' && (
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-100 space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-xs font-bold text-slate-500 block mb-1">{t('wizard.review.schedule.day_of_month') || 'Día del mes'}</label>
                      <select value={monthDays[0]} onChange={e => setMonthDays([e.target.value, monthDays[1]])} className="w-full p-2 rounded-lg border-slate-200 text-sm">
                        {[...Array(31)].map((_, i) => <option key={i + 1} value={i + 1}>{i + 1}</option>)} <option value="L">{t('wizard.review.schedule.last_of_month') || 'Último día (L)'}</option>
                      </select>
                    </div>
                    <div>
                      <label className="text-xs font-bold text-slate-500 block mb-1">{t('wizard.review.schedule.time') || 'Hora'}</label>
                      <input type="time" value={time} onChange={e => setTime(e.target.value)} className="w-full p-2 rounded-lg border-slate-200 text-sm" />
                    </div>
                  </div>
                </div>
              )}

              {/* ZONA HORARIA Y CRON RESULTANTE */}
              <div className="space-y-3">
                <label className="text-xs font-bold text-slate-500 uppercase flex items-center">
                  <Globe className="w-3.5 h-3.5 mr-1" /> {t('wizard.review.schedule.timezone') || 'Zona Horaria'}
                </label>
                <select value={timezone} onChange={(e) => setTimezone(e.target.value)} className="w-full text-sm border-slate-200 rounded-xl p-2.5 outline-none bg-slate-50">
                  {TIMEZONES.map(group => (
                    <optgroup key={group.group} label={group.group}>
                      {group.options.map(opt => <option key={opt.v} value={opt.v}>{opt.l}</option>)}
                    </optgroup>
                  ))}
                </select>

                <div>
                  <label className="text-xs font-bold text-slate-500 uppercase mb-1.5 flex items-center">
                    <Clock className="w-3.5 h-3.5 mr-1" /> {t('wizard.review.schedule.cron_result') || 'Código CRON Resultante'}
                  </label>
                  <input type="text" value={cronExpression} onChange={(e) => setCronExpression(e.target.value)} readOnly={schedType !== 'custom'} className={`w-full text-sm rounded-xl p-2.5 outline-none font-mono ${schedType === 'custom' ? 'bg-white border-indigo-300 border-2' : 'bg-slate-100 border-slate-200 border text-slate-500'}`} />
                </div>
              </div>

            </div>
          )}
        </div>
      </div>
    </div>
  );
};